import { render } from "./ProfileLabel.vue?vue&type=template&id=5078d062&scoped=true"
import script from "./ProfileLabel.vue?vue&type=script&lang=js"
export * from "./ProfileLabel.vue?vue&type=script&lang=js"

import "./ProfileLabel.vue?vue&type=style&index=0&id=5078d062&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5078d062"]])

export default __exports__